import { fromJS } from 'immutable'
import {
  LEAVE_ENTITLEMENT_CREATE_REQUEST,
  LEAVE_ENTITLEMENT_CREATE_SUCCESS,
  LEAVE_ENTITLEMENT_CREATE_FAILURE,
  LEAVE_ENTITLEMENT_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_ENTITLEMENT_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_ENTITLEMENT_CREATE_SUCCESS:
      return state
        .set('createdLeaveEntitlement', fromJS(action.payload.createdLeaveEntitlement))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('createdLeaveEntitlement', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_CREATE_RESET:
      return state
        .delete('createdLeaveEntitlement')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-entitlement/leave-entitlement-create-reducer.js